import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  DEFAULT_TOKEN_DECIMALS,
  MARGINX_BRANDING,
  RPC_API_KEY,
} from "./shared";

// ============================================
// ETH MAINNET (Chain ID: 1)
// ============================================
export const ethMainnetConfig: ChainConfig = {
  chainId: ChainIdEnum.ETH_MAINNET,
  name: "Mainnet",
  shortName: "eth",
  isTestnet: false,
  rpcUrls: [`https://eth-mainnet.g.alchemy.com/v2/${RPC_API_KEY}`],
  explorerUrl: "https://etherscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      "usdc-native": "",
      usdt: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      weth: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      wbtc: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      l2usdc: "0x643aaB1618c600229785A5E06E4b2d13946F7a1A",
      l2usdt: "0xE281ACD6947932E402B97c2b49E00F1847598a19",
      l2weth: "0xB9D571c1EC576300f01ddfA5A082D9c571E45e36",
      l2wbtc: "0xb49682E77D57Af214cd90310C7A02f1eDe855988",
      govToken: "0xb528edbef013aff855ac3c50b381f253af13b997",
    },
    bridge: {
      l1DepositHelper: "0xc3Bb52E6118F05Dd8ad4e1C1a1398281cd7c4C7f",
      l1StandardBridge: "0x4082C9647c098a6493fb499EaE63b5ce3259c574",
      l2StandardBridge: "0x4200000000000000000000000000000000000010",
      l2WithdrawProxy: "0x4d44B9AbB13C80d2E376b7C5c982aa972239d845",
      exchangePass: "0x75ad4c505E5b4Bb65b832c91eB76529cE07220F1",
      strategies: "",
      staking: "0x38913051e01d4f6910cb66bb9ac3cb77d746ad81",
    },
  },
  signingDomain: { name: "MarginX Mainnet", version: "1" },
  socketL2ChainId: 2999,
  branding: MARGINX_BRANDING,
};
